import React from "react";
import Modaal from "./modaal";
import { FormInputs } from "../inputs";
import { Row } from "react-bootstrap";

const OtpModal = ({
    show,
    onHide,
    inputFields,
    title,
    footer,
    centered,
    className,
    credentials,
    handleChange,
    errors,
}) => {
    const renderFormContent = () => (
        <>
            {errors?.otp && (
                <div className="exado_body_text form-label-error-span text-center">
                    {errors?.otp}
                </div>
            )}
            <Row>
                {inputFields?.map((field, index) => (
                    <>
                        <FormInputs
                            key={index}
                            type={field.type}
                            placeholder={field.placeholder}
                            value={credentials[field.name] || ""}
                            onChange={handleChange}
                            name={field.name}
                            maxLength={field.maxLength}
                            md={field.md}
                            className={errors?.otp != null ? "form-label-error-span" : ""}
                        />
                    </>
                ))}
            </Row>
        </>
    );

    return (
        <Modaal
            size="xl"
            show={show}
            onHide={onHide}
            title={title}
            bodyContent={renderFormContent()}
            footer={footer}
            centered={centered}
            className={className}
            backdrop="static"
        />
    );
};

export default OtpModal;
